import React, { useEffect, useState } from "react";
import { enterFullscreen, exitFullscreen } from "../../../utils/deviceManagement";
import { Button } from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import { EP, proctoringSession, Events } from "../../../utils/proctoring";
import { ingestLog } from "../../../services/utils/appInfoApi";
import { Link, useNavigate } from "react-router-dom";

import alert_img from '../../../assets/images/exams/warning-alert.svg'
import { resetProctoringSession } from "../../../features/Exam/examSlice";

const ActiveProctoringCheck = () => {
    const [isProctoringActive, setIsProctoringActive] = useState(true);

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(()=> {
        const checkProctoringwindow = () => {
          
          if(!proctoringSession?.isWindowOpen()){
            setIsProctoringActive(false);
          } else {
            setTimeout(checkProctoringwindow,30000)
          }
        }
        setTimeout(checkProctoringwindow,30000)
    },[])

    const resetProctoringAndScreen = () => {

        const checkFullScreen = () => {
            const fsElement =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

            return(!!fsElement);
        };

        dispatch(resetProctoringSession())
        if(checkFullScreen())
            exitFullscreen()
        navigate('/exams')
    }

  if (isProctoringActive) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "black",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.5rem",
        zIndex: 9999,
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <img src={alert_img} />
      <h3>{t.proctoring.proctoring_not_found}</h3>
      <p>{t.proctoring.proctoring_not_found_text}</p>
      <Button onClick={resetProctoringAndScreen} >{t.exam.errors.go_back}</Button>
    </div>
  );
};

export default ActiveProctoringCheck;